// extracted by mini-css-extract-plugin
export default {"container":"ZqWenq","spacing":"cTlMxr"};